import { useState } from "react";
import { Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneIcon from "@mui/icons-material/Done";
import { useNotify } from "react-admin";

// Shared copy-to-clipboard action. Shows a short "copied" confirmation on the button itself in addition to
// the toast, so it is obvious the click did something.
const CopyToClipboardButton = ({
  text,
  label = "Копирай",
  copiedLabel = "Копирано",
  successMessage = "Копирано в клипборда!",
  disabled,
  ...rest
}) => {
  const notify = useNotify();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      notify(successMessage, { type: "success" });
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      // navigator.clipboard is unavailable outside a secure context (and can be denied by the user).
      console.error("Неуспешно копиране в клипборда", error);
      notify("Копирането не беше успешно. Маркирайте текста и копирайте ръчно.", { type: "error" });
    }
  };

  return (
    <Button
      onClick={handleCopy}
      variant="outlined"
      size="small"
      disabled={disabled || !text}
      startIcon={copied ? <DoneIcon /> : <ContentCopyIcon />}
      {...rest}
    >
      {copied ? copiedLabel : label}
    </Button>
  );
};

export default CopyToClipboardButton;
